var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['question_btn flex-row', _vm.buttonClass, _vm.answerStatusClass, {selected: _vm.isAnswerSelected}],attrs:{"type":""},on:{"click":function($event){$event.preventDefault();_vm.handleAnswerSelected($event)}}},[_c('span',[_vm._v(_vm._s(_vm.choice))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a86ebca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/game/GameAnswerItem.vue
// module id = null
// module chunks = 